export const WEEKDAY_OPTIONS = [
  { value: 'monday', label: 'Monday' },
  { value: 'tuesday', label: 'Tuesday' },
  { value: 'wednesday', label: 'Wednesday' },
  { value: 'thursday', label: 'Thursday' },
  { value: 'friday', label: 'Friday' },
  { value: 'saturday', label: 'Saturday' },
  { value: 'sunday', label: 'Sunday' },
];

const WEEKDAY_ORDER = WEEKDAY_OPTIONS.map((day) => day.value);

function capitalize(value) {
  const text = String(value || '').trim();
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1);
}

function formatClock(value) {
  const text = String(value || '').trim();
  if (!text) return '-';

  const [hoursPart, minutesPart = '00'] = text.split(':');
  const hours = Number(hoursPart);
  const minutes = Number(minutesPart);

  if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return text;

  const period = hours >= 12 ? 'PM' : 'AM';
  const normalizedHours = hours % 12 || 12;
  const normalizedMinutes = String(minutes).padStart(2, '0');
  return `${normalizedHours}:${normalizedMinutes} ${period}`;
}

export function normalizeDayList(daysOfWeek = []) {
  const source = Array.isArray(daysOfWeek) ? daysOfWeek : [];
  const cleaned = source
    .map((day) => String(day || '').trim().toLowerCase())
    .filter(Boolean);
  return WEEKDAY_ORDER.filter((day) => cleaned.includes(day));
}

export function normalizeIntakeSession(session = {}) {
  const daysOfWeek = normalizeDayList(session.daysOfWeek);
  return {
    id: String(session.id || '').trim(),
    label: String(session.label || '').trim(),
    startTime: String(session.startTime || '08:00').trim() || '08:00',
    endTime: String(session.endTime || '10:00').trim() || '10:00',
    daysOfWeek: daysOfWeek.length ? daysOfWeek : ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'],
  };
}

export function normalizeIntakeSessions(sessions = []) {
  if (!Array.isArray(sessions)) return [];
  return sessions.map(normalizeIntakeSession).filter((session) => session.startTime && session.endTime);
}

export function formatIntakeSessionLabel(session = {}) {
  const normalized = normalizeIntakeSession(session);
  const days = normalized.daysOfWeek.map(capitalize).join(', ');
  const time = `${formatClock(normalized.startTime)} - ${formatClock(normalized.endTime)}`;
  return normalized.label ? `${normalized.label}: ${days} ${time}` : `${days} ${time}`;
}

export function formatIntakeSessionsSummary(sessions = []) {
  const normalized = normalizeIntakeSessions(sessions);
  if (!normalized.length) return 'Open session';
  return normalized.map(formatIntakeSessionLabel).join(' | ');
}

export function createDefaultIntakeSession() {
  return normalizeIntakeSession({
    label: 'Weekday morning',
    startTime: '08:00',
    endTime: '10:00',
    daysOfWeek: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'],
  });
}
